import {Pill} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {REPORT_FILTERS_WIDGET_NAMESPACE} from '../consts'

export const useCustomPillsRender = (optionsLength: number, onClear: () => void) => {
  const {t} = useTranslation(REPORT_FILTERS_WIDGET_NAMESPACE)

  return (selectedValues: (string | number)[], dataId: string) => {
    const allOptionsSelected = selectedValues.length === optionsLength
    return (
      <Pill
        key="all"
        text={
          allOptionsSelected
            ? t('filterOptions.allSelected')
            : `${selectedValues.length} ${t('filterOptions.selected')}`
        }
        type="neutral"
        size="regular"
        variant="shade"
        className="mr-2"
        closable={true}
        onClose={onClear}
        data-cy={`${dataId}-pills`}
      />
    )
  }
}
